import React, { Component } from 'react';
import css from './Scheduled.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import moment from "moment";
import axios from "axios";
import {connect} from "react-redux";
import getDateQry from "../../helpers/dateHelpers";
import {SCHEDULABLE_QUERY_TIME_PERIOD} from "../../helpers/timePeriods";
import {Link} from "react-router-dom";
import _ from 'lodash';


/**
 * @class
 *
 * Scheduled page.
 */
const Scheduled = class extends Component  {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    currentDate = moment().format('dddd, MMM Do');
    tomorrowDate = moment().add(1, 'days').format('dddd, MMM Do');

    postRequestData = {
        "limit": 1000,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "CreatedDate",
            "RecordTypeId",
            "RecordType.Name",
            "Assigned_Crew__c",
            "Assigned_Crew__r.Name",
            "Assigned_Crew__r.Outside_Contractor__c",
            "Assigned_Crew_2__c",
            "Assigned_Crew_2__r.Name",
            "Assigned_Crew_2__r.Outside_Contractor__c",
            "Cancel_Date_Time__c",
            "Cancellation_in_Progress__c",
            "City__c",
            "Codes_Gates_Animals__c",
            "Customer_Name__c",
            "Final_Scheduled_Date__c",
            "Final_Scheduled_Time__c",
            "Financing_Partner__c",
            "Ground_Mount__c",
            "Imging_Job_Created__c",
            "Location__r.Name",
            "Number_of_surveyors_needed__c",
            "Customer_will_be_home__c",
            "Will_the_customer_be_home__c",
            "Permission_to_access_roof__c",
            "Permission_to_access_the_roof__c",
            "Opportunity__c",
            "Opportunity__r.Jurisdiction_opp__r.Field_Notes__c",
            "Opportunity__r.Name",
            "Opportunity__r.Sales_Representative__r.Name",
            "Opportunity__r.Sales_Representative__r.Phone",
            "Opportunity__r.Sales_Representative_2__r.Name",
            "Opportunity__r.Sales_Representative_2__r.Phone",
            "Opportunity__r.Sales_Representative_3__r.Name",
            "Opportunity__r.Sales_Representative_3__r.Phone",
            "Primary_Phone__c",
            "Scheduled__c",
            "Secondary_Phone__c",
            "Shade_Data_Method__c",
            "Site_Survey_Completed__c",
            "Site_Survey_Date__c",
            "Site_Survey_Notes__c",
            "Site_Survey_Scheduled_Start__c",
            "Site_Survey_Scheduled_End__c",
            "SS_Time_Placeholder__c",
            "Schedulable_Complete__c",
            "Schedulable_Notes__c",
            "Schedulable_Event__r.Name",
            "Scheduled_Date__c",
            "Start_Time_24h__c",
            "State__c",
            "Street__c",
            "Structure_Levels__c",
            "Survey_Start_Time__c",
            "Surveyor_Notes__c",
            "System_Size__c",
            "Time_Slot__c",
            "Time_Window__c",
            "Type__c",
            "Unschedule_Details__c",
            "Survey_Completed_By__c",
            "Survey_Completed_By__r.Name",
            "Second_surveyor__c",
            "Survey_Additions__c",
            "Zip__c",
            "Inspection_Outcome__c",
            "Jobsite_Photos__c",
            "Field_Notes__c"
        ],
        "where": {
            "Scheduled__c": true,
            "$or": [
                {
                    "Assigned_Crew__c": this.props.user.apiId
                },
                {
                    "Assigned_Crew_2__c": this.props.user.apiId
                }
            ]
        },
        "date": {
            ...getDateQry(SCHEDULABLE_QUERY_TIME_PERIOD, 'Final_Scheduled_Date__c')
        }
    };

    // ---------- state: ----------
    state = {
        jobsToday: [],
        jobsTomorrow: [],
        jobsPast: [],
        jobsFuture: []
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestData,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const sessions = res.data.records
                    .map(job => {
                        let scheduledTimeFormat;
                        let placeholder = job.Final_Scheduled_Time__c.slice(0, 8);
                        let [time, modifier] = placeholder.split(' ')
                        if(modifier === 'PM'){
                            let number = parseInt(time.split(':'));
                            if(number !== 12){
                                number = number + 12;
                            }

                            scheduledTimeFormat = number + ':00';
                        } else {
                            scheduledTimeFormat = time;
                        }

                        return {
                            Id: job.Id,
                            Name: job.Opportunity__r.Name,
                            City: job.City__c,
                            ScheduledTime: job.Final_Scheduled_Time__c,
                            ScheduledDate: job.Final_Scheduled_Date__c,
                            Type: job.Type__c,
                            ScheduledStart: moment(job.Final_Scheduled_Date__c ).format('DD-MM-YYYY') + ' ' + scheduledTimeFormat,
                        };
                    });

                const jobsList = _.orderBy(sessions, ['ScheduledStart'], ['asc']);

                // filter/split data into arrays by given time interval:
                const TODAY = moment();
                const TOMORROW = moment().add(1, 'days');
                const THREE_DAYS_AGO = moment().subtract(3, 'days');
                const FUTURE_FIVE_DAYS = moment().add(5, 'days');

                const jobsToday = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isSame(TODAY, 'day');
                });

                const jobsTomorrow = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isSame(TOMORROW, 'day');
                });

                const jobsPast = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isBetween(THREE_DAYS_AGO, TODAY, 'day', '[)');
                });

                const jobsFuture = jobsList.filter(job => {
                    return moment(job.ScheduledDate)
                        .isBetween(TODAY, FUTURE_FIVE_DAYS, 'day', '()');
                });

                this.setState({
                    jobsToday,
                    jobsTomorrow,
                    jobsPast,
                    jobsFuture
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in Scheduled Jobs:\n', err);
                }
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    render() {
        return (
            <div className={css.Scheduled}>
                <SectionHeading heading="Scheduled Jobs" />

                <div className="row mt-4">
                    <div className="col-12 col-lg-6">
                        <h2>Today <span>{ this.currentDate }</span></h2>
                        <table className={css.Scheduled__Table}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Time</th>
                                <th>Type</th>
                            </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.jobsToday
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td><Link to={`/scheduled/${job.Id}`}>{job.Name}</Link></td>
                                                <td>{job.City}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                        <h2>Tomorrow <span>{ this.tomorrowDate }</span></h2>
                        <table className={css.Scheduled__Table}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Time</th>
                                <th>Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.jobsTomorrow
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td><Link to={`/scheduled/${job.Id}`}>{job.Name}</Link></td>
                                                <td>{job.City}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ----- row 2: ----- */}
                <div className="row mt-4">
                    <div className="col-12 col-lg-6">
                        <h2>Past <span>3 Days</span></h2>
                        <table className={css.Scheduled__TableWithDate}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.jobsPast
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td><Link to={`/scheduled/${job.Id}`}>{job.Name}</Link></td>
                                                <td>{job.City}</td>
                                                <td>{moment(job.ScheduledDate).format('MMM D')}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                        <h2>Future <span>5 Days</span></h2>
                        <table className={css.Scheduled__TableWithDate}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>City</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.jobsFuture
                                    .map(job => {
                                        return (
                                            <tr key={job.Id}>
                                                <td><Link to={`/scheduled/${job.Id}`}>{job.Name}</Link></td>
                                                <td>{job.City}</td>
                                                <td>{moment(job.ScheduledDate).format('MMM D')}</td>
                                                <td>{job.ScheduledTime}</td>
                                                <td>{job.Type}</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(Scheduled);
